import React from "react";
import { Link } from "react-router-dom";

export default function OwnerCouponForm({
  title,
  formData,
  loading,
  onChange,
  onSubmit,
  submitLabel,
  backPath = "/coupons",
}) {
  return (
    <section className="main-sec">
      <div className="row align-items-center">
        <div className="col-lg-8">
          <div className="dashboard-title">
            <h4 className="dash-head">
              <i className="fa fa-ticket me-2" />
              {title}
            </h4>
          </div>
          <div className="custom-bredcump">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/coupons">Coupons</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  {title}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="col-lg-4 d-flex justify-content-lg-end">
          <Link to={backPath} className="btn btn-outline-primary mt-2 mt-lg-0">
            <i className="fa fa-arrow-left me-1" />
            Back to Coupons
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12">
          <div className="cards edit-usr">
            <div className="alert alert-info mb-4">
              This coupon will apply only to bookings of your library.
            </div>

            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Coupon Code<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="text"
                    name="code"
                    className="form-control"
                    value={formData.code}
                    onChange={onChange}
                    placeholder="Enter coupon code"
                    required
                    style={{ textTransform: "uppercase" }}
                  />
                </div>

                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Discount Type<sup className="text-danger">*</sup>
                  </label>
                  <select
                    name="discountType"
                    className="form-control"
                    value={formData.discountType}
                    onChange={onChange}
                    required
                  >
                    <option value="percentage">Percentage</option>
                    <option value="fixed">Fixed Amount</option>
                  </select>
                </div>

                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    {formData.discountType === "fixed"
                      ? "Discount Amount"
                      : "Discount (%)"}
                    <sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="number"
                    name="discountValue"
                    className="form-control"
                    value={formData.discountValue}
                    onChange={onChange}
                    min="1"
                    step="0.01"
                    max={formData.discountType === "percentage" ? "100" : undefined}
                    placeholder={
                      formData.discountType === "fixed"
                        ? "Enter amount"
                        : "Enter percentage"
                    }
                    required
                  />
                </div>

                <div className="col-lg-6 mb-4">
                  <label className="form-label">Status</label>
                  <select
                    name="isActive"
                    className="form-control"
                    value={formData.isActive}
                    onChange={onChange}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>

                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Valid From<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="date"
                    name="validFrom"
                    className="form-control"
                    value={formData.validFrom}
                    onChange={onChange}
                    required
                  />
                </div>

                <div className="col-lg-6 mb-4">
                  <label className="form-label">
                    Valid Till<sup className="text-danger">*</sup>
                  </label>
                  <input
                    type="date"
                    name="validTill"
                    className="form-control"
                    value={formData.validTill}
                    onChange={onChange}
                    min={formData.validFrom || undefined}
                    required
                  />
                </div>

                <div className="col-lg-12 text-center">
                  <button type="submit" className="btn-save" disabled={loading}>
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" />
                        Saving...
                      </>
                    ) : (
                      <>
                        <i className="fa fa-save me-1" />
                        {submitLabel}
                      </>
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>
        {`
          .btn-save {
            background: #26a084;
            color: #fff;
            border: none;
            padding: 10px 30px;
            border-radius: 5px;
            font-weight: 500;
            transition: all 0.3s ease;
          }

          .btn-save:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(38, 160, 132, 0.25);
          }
        `}
      </style>
    </section>
  );
}
